import { render, staticRenderFns } from "./RolesList.vue?vue&type=template&id=e9895342&scoped=true"
import script from "./RolesList.vue?vue&type=script&lang=js"
export * from "./RolesList.vue?vue&type=script&lang=js"
import style0 from "./RolesList.vue?vue&type=style&index=0&id=e9895342&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9895342",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9895342')) {
      api.createRecord('e9895342', component.options)
    } else {
      api.reload('e9895342', component.options)
    }
    module.hot.accept("./RolesList.vue?vue&type=template&id=e9895342&scoped=true", function () {
      api.rerender('e9895342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/user/RolesList.vue"
export default component.exports